import type { DevScenarioEntry } from '@arya/shared/msw-cloudflare';

import { ACCOUNT_SCENARIOS } from './account-scenarios';
import { SIGN_IN_SCENARIOS } from './sign-in-scenarios';
import { SLOW_API } from './slow-api-scenario';
import { WALLET_SCENARIOS } from './wallet-scenarios';

export const DEV_SCENARIO_ENTRIES: readonly DevScenarioEntry[] = [
  ...WALLET_SCENARIOS,
  ...ACCOUNT_SCENARIOS,
  ...SIGN_IN_SCENARIOS,
];

export const LAST_DEV_SCENARIO_ENTRIES: readonly DevScenarioEntry[] = [SLOW_API];
